class CarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Carousel-"]');
      this.sliderItems = this.querySelectorAll('[id^="CarouselSlide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.carousel-counter--current');
      this.sliderControlWrapper = this.querySelector('.carousel-buttons');
      this.sliderDotsWrapper = this.querySelector('.carousel-dots');
      this.pageTotalElement = this.querySelector('.carousel-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.sliderControlWrapper) return;
  
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
      if (this.sliderItemsToShow.length === 0) return;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Carousel-"]');
      this.initPages();
    }
  
    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
  
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
  
      if (this.enableSliderLooping) return;
  
      if (this.isSlideVisible(this.sliderItemsToShow[0])) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (this.isSlideVisible(this.sliderLastItem)) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
  
      // update pagination on scroll event
      this.sliderControlButtons = this.querySelectorAll('.carousel-dot');
  
      if (!this.sliderControlButtons.length) return;
  
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('carousel-dot--current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('carousel-dot--current');
    }
  
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
      event.preventDefault();
  
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
    onDotClick(event) {
      event.preventDefault();
  
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
  
      let dots = document.querySelectorAll('.carousel-dot')
      dots.forEach((el) => {
        if (el == event.currentTarget) {
          el.classList.contains('carousel-dot--current')
            ? el.classList.remove('carousel-dot--current')
            : el.classList.add('carousel-dot--current')
        } else {
          el.classList.remove('carousel-dot--current')
        }
      })
    }
}
  
customElements.define('carousel-component', CarouselComponent);